





































import demo1 from './demo1.vue';
import Anchor from '@/packages/d-anchor';
import Vue from 'vue';
import Component from 'vue-class-component';
import DTable from '@/packages/d-table';
import title from '../../packages/d-table/demo/README.md';
import props from '../../packages/d-table/demo/props.md';

Vue.use(Anchor);
Vue.use(DTable);
@Component({
  name: 'ComponentDemo',
  components: {
    demo1
  }
})
export default class ComponentDemo extends Vue {
  public title = title;
  public props = props;

  public getContainer() {
    return document.getElementById('app-content');
  }
}
